<template>
  <div class="policy-content">
    <div class="policy-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
      <h2>תקנון השימוש</h2>
    </div>

    <div class="policy-intro">
      <p>הי חברים יקרים! כיף שהצטרפתם אלינו!</p>
      <p>אנחנו מעריכים ומודים לכם על העשיה הטובה. לפני שנתחיל, חשוב לנו לציין את הכללים הבאים:</p>
    </div>

    <div class="policy-rules">
      <div class="rule-item">
        <div class="rule-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <span>על כל משתמש להכניס פרטים אישיים מאומתים שלו בלבד.</span>
      </div>

      <div class="rule-item">
        <div class="rule-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
        </div>
        <span>האפליקציה נוצרה לשמש את מחפשי ההתנדבות ונותני ההתנדבות. אנא הקפידו ושאלו רק בקשות ראויות שהן בגדר התנדבות.</span>
      </div>

      <div class="rule-item">
        <div class="rule-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <span>נותני התנדבות - כאשר אתם נרשמים להתנדבות, זכרו שיש אנשים שמחכים לכם! גלו אחריות ובטלו בזמן מראש אם יש צורך (עד 8 שעות).</span>
      </div>

      <div class="rule-item">
        <div class="rule-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </div>
        <span>אם נתקלתם בבעיות, נשמח לעזור. תוכלו לפנות אלינו באימייל: volunteering200@gmail.com</span>
      </div>

      <div class="rule-item">
        <div class="rule-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>
        <span>ניתן לעיין ב<router-link class="privacy-link" to="/privacy-policy" target="_blank">מדיניות הפרטיות</router-link> שלנו.</span>
      </div>
    </div>

    <p class="policy-footer-text">אנחנו כאן כדי לסייע ולתמוך, אז אל תהססו לפנות אלינו כשצריך! 😊</p>

    <button class="approve-btn" @click="authorizePolicy">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      אני מאשר/ת את התקנון
    </button>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  setup(props, { emit }) {
    const policyAuth = ref(false)

    const authorizePolicy = () => {
      policyAuth.value = true
      emit('policy-authorized', policyAuth.value)
    }

    return { policyAuth, authorizePolicy }
  }
}
</script>

<style scoped>
.policy-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.policy-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #667eea;
}

.policy-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.policy-intro {
  text-align: center;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.policy-intro p {
  margin: 0 0 8px;
}

.policy-rules {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 220px;
  overflow-y: auto;
  padding: 12px;
  background: #f9fafb;
  border-radius: 12px;
}

.rule-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #374151;
  line-height: 1.5;
}

.rule-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.privacy-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.privacy-link:hover {
  text-decoration: underline;
}

.policy-footer-text {
  text-align: center;
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.approve-btn {
  width: 100%;
  height: 46px;
  padding: 0 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.approve-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
}

.approve-btn:active {
  transform: translateY(0);
}

/* Mobile Mode */
@media (max-width: 480px) {
  .policy-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 10px;
    overflow: hidden;
  }

  .policy-header {
    flex-shrink: 0;
    gap: 8px;
  }

  .policy-header h2 {
    font-size: 18px;
  }

  .policy-header svg {
    width: 24px;
    height: 24px;
  }

  .policy-intro {
    flex-shrink: 0;
    font-size: 13px;
  }

  .policy-intro p {
    margin: 0 0 4px;
  }

  .policy-rules {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 10px;
    gap: 10px;
    /* Hide scrollbar */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .policy-rules::-webkit-scrollbar {
    display: none;
  }

  .rule-item {
    font-size: 12px;
    gap: 8px;
  }

  .rule-icon {
    width: 28px;
    height: 28px;
    min-width: 28px;
  }

  .rule-icon svg {
    width: 14px;
    height: 14px;
  }

  .policy-footer-text {
    flex-shrink: 0;
    font-size: 12px;
  }

  .approve-btn {
    flex-shrink: 0;
    height: 44px;
    font-size: 14px;
  }
}

/* Low height phones */
@media (max-height: 700px) and (max-width: 480px) {
  .policy-content {
    gap: 8px;
  }

  .policy-header h2 {
    font-size: 16px;
  }

  .policy-intro {
    font-size: 12px;
  }

  .policy-rules {
    padding: 8px;
    gap: 8px;
  }

  .rule-item {
    font-size: 11px;
  }

  .rule-icon {
    width: 24px;
    height: 24px;
    min-width: 24px;
  }

  .policy-footer-text {
    font-size: 11px;
  }

  .approve-btn {
    height: 40px;
    font-size: 13px;
  }
}
</style>
